import { Box, Grid2, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
export default function LeftSection() {
  // StepItem component for rendering each step with an icon
  const StepItem = ({ step, description }) => {
    return (
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: 2 }}>
        <CheckCircleOutlineIcon sx={{ color: "#fafafa", marginRight: 1 }} />
        <Typography variant="body1">
          Step {step}: {description}
        </Typography>
      </Box>
    );
  };
  return (
    <Grid2
      size={{ xs: 12, md: 3 }}
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          background: (theme) => theme.palette.primary.main,
          height: "100%",
          paddingY: { xs: 2, md: 4 },
          paddingX: 2,
          borderRadius: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "#fafafa",
          justifyContent: { xs: "center", md: "start" },
        }}
      >
        <img src="/logo_plain.png" width={"80%"} alt="logo" />
        <Typography variant="h4" mt={{ xs: 2, md: 6 }}>
          Therapist Intake Form
        </Typography>
        {/* Step description section */}
        <Stack mt={4} display={{ xs: "none", md: "flex" }}>
          <Typography variant="h6" mb={2} fontWeight={400}>
            Please complete the following steps
          </Typography>
          <StepItem step={1} description="Personal Info" />
          <StepItem step={2} description="Professional Info" />
          <StepItem step={3} description="Additional Info" />
        </Stack>
      </Paper>
    </Grid2>
  );
}
